import { Spin } from 'antd'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import { getResPaymentConfirmation } from '../../repositories/apiRepo'
import { userProfileAtom } from '../../store/userProfile'

const CallbackPage = () => {
  const [userProfile] = useRecoilState(userProfileAtom)
  const [searchParams] = useSearchParams()
  const AccessID = searchParams.get('AccessID')

  const redirectURL =
    localStorage.getItem('redirectURL') || process.env.REACT_APP_FE_URL
  useEffect(() => {
    const getResPayment = async () => {
      try {
        if (AccessID) {
          await getResPaymentConfirmation({ access_id: AccessID })

          window.location.href = `${redirectURL}/?payment=success`
          localStorage.removeItem('redirectURL')
        }
      } catch (error: any) {
        if (error?.response?.data?.error?.message) {
          window.location.href = `${redirectURL}/?payment=error&error=${error.response.data.error.message}`
        } else {
          window.location.href = `${redirectURL}/?payment=error`
        }
      }
    }
    if (userProfile) {
      getResPayment()
    }
  }, [userProfile])
  return (
    <div className='w-full h-full bg-[#00000059] flex justify-center items-center'>
      <Spin></Spin>
    </div>
  )
}

export default CallbackPage
